import Styled from "styled-components";

export const Container = Styled.div`
`;

export const ContainerGrid = Styled.div`
  display: grid;
  grid-gap: 10px;
  grid-auto-flow: ${(props) => props.direction || "row"};
  grid-template-columns: 20px 75% 40px;
  margin-bottom: 10px;
`;

export const Label = Styled.h1`
`;
export const Space = Styled.div`
`;

export const EmptyCard = Styled.div`

  #goHomeButton {
    margin-top: 80px;
    margin-bottom: 180px;
  }
`;

export const Trash = Styled.div`
`;

export const Radio = Styled.input`
`;
export const Link = Styled.div`
`;

export const GroupIcons = Styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
export const TitleProduct = Styled.p`
`;

export const Center = Styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Line = Styled.div`
margin-top: 5px;
margin-bottom: 5px;
border: solid 1px #F0F2F5;
`;

export const Total = Styled.p`
font-weight: 700;
font-style: bold;
font-size: 16px;
line-height: 150%;
color: ${props => props.theme.whitelabel?.theme?.text_primary_color};
letter-spacing: 0%;
`

export const LabelText = Styled.p`
  font-weight: 500;
  font-style: medium;
  font-size: 16px;
  line-height: 150%;
  color: ${props => props.theme.whitelabel?.theme?.text_primary_color};
  letter-spacing: 0%;
`

/* ===== Desktop (>=1024px): carrinho em 2 colunas ===== */
export const CartLayout = Styled.div`
  @media (min-width: 1024px) {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 360px;
    gap: 32px;
    align-items: start;
    margin-top: 24px;
    .cart-list .row { align-items: center; }
    .cart-list .col-4 { flex: 0 0 auto; width: auto; max-width: none; }
    .cart-list .col-8 { flex: 1 1 auto; width: auto; max-width: none; }
    .cart-list .img-thumbnail { width: 88px; height: 88px; object-fit: cover; }
  }
`;

export const SummaryCard = Styled.div`
  @media (min-width: 1024px) {
    background: #F5F5F7;
    border-radius: 8px;
    padding: 20px 16px;
    position: sticky;
    top: 100px;

    .cart-actions {
      display: flex;
      flex-direction: column;
      gap: 12px;
      margin-top: 8px;
    }
  }
`;

/* Desktop: alinha o Container do Bootstrap ao padrão do header (1320/32) */
export const PageWrap = Styled.div`
  @media (min-width: 1024px) {
    .container {
      max-width: 1320px;
      padding-left: 32px;
      padding-right: 32px;
    }
  }
`;